export default __webpack_public_path__ + "static/17-e103e823e5b0c210114901df54e08437.png";